(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["do3d-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('d3-standard-checkout')) {
    customElements.define('d3-standard-checkout', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.button = this.querySelector('button');
        this.error = this.querySelector('[role="alert"]');
        this.button.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.busy) return;
          const form = this.closest('form');
          if (form && !form.reportValidity()) return;
          const data = form ? new FormData(form) : new FormData();
          if (this.dataset.variantId) {
            data.set('id', this.dataset.variantId);
            data.set('quantity', this.dataset.quantity || '1');
          }
          if (!data.get('id')) return;
          this.busy = true;
          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          this.error.hidden = true;
          try {
            const { digitalCartFetch, ensureDigitalQuantity } = await import('@theme/do3d-digital-quantity');
            const response = await digitalCartFetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: data
            });
            const result = await response.json();
            if (!response.ok || result.status) {
              throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
            }
            await ensureDigitalQuantity();
            window.location.assign(this.dataset.checkoutUrl);
          } catch (error) {
            this.error.textContent = error.message || this.dataset.error;
            this.error.hidden = false;
            this.busy = false;
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["do3d-local-print-help"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'do3d-local-print-pending';
  const optional = ['contact[Country]', 'contact[Needed by]', 'contact[Budget]'];
  const read = () => { try { const p = JSON.parse(sessionStorage.getItem(key)); if (p && Date.now() - p.time < 1800000) return p; sessionStorage.removeItem(key); } catch {} return null; };
  const save = p => sessionStorage.setItem(key, JSON.stringify(p));
  const accepted = (form, selector, field) => { const r = form.querySelector(selector); return location.hash === '#' + form.id && r?.dataset[field] === 'true' && r.dataset.lphErrors === 'false'; };
  const clearResult = () => { const u = new URL(location.href); u.searchParams.delete('contact_posted'); u.searchParams.delete('customer_posted'); u.hash = ''; history.replaceState(null, '', u.pathname + u.search); };
  const initialize = () => {
    document.querySelectorAll('form[data-print-help]').forEach(form => {
      const p = read();
      const matching = p && p.id === form.id && p.path === location.pathname;
      const current = matching && p.version === 2;
      const confirmation = document.querySelector('[data-lph-confirmation="' + form.id + '"]');
      const stage = document.querySelector('[data-lph-newsletter-stage="' + form.id + '"]');
      const newsletter = stage.querySelector('form');
      const status = type => { confirmation.hidden = false; confirmation.textContent = confirmation.dataset[type]; };
      const retract = () => { form.querySelector('[data-lph-fields]').hidden = true; form.closest('.do3d-print-help').open = false; };
      const finish = type => { retract(); stage.hidden = true; status(type); if (current) { p.stage = 'done'; p.result = type; delete p.fields; try { save(p); } catch {} } clearResult(); };
      const configure = () => { newsletter.elements['contact[email]'].value = p.fields['contact[email]']; };
      if (current && p.stage === 'done') { finish(p.result); return; }
      if (current && p.stage === 'customer') {
        retract();
        if (accepted(newsletter, '[data-lph-newsletter-result]', 'lphNewsletterResult')) { finish('bothOk'); return; }
        configure(); stage.hidden = false; status('signupPending');
        return;
      }
      if (accepted(form, '[data-lph-result]', 'lphResult')) {
        retract();
        if (!current || !p.marketing) { finish('contactOk'); return; }
        p.stage = 'customer';
        try { save(p); } catch { status('signupUnavailable'); return; }
        configure(); stage.hidden = false; status('signupPending'); clearResult();
        let sent = false;
        if (window.Shopify?.captcha?.protect) {
          try { window.Shopify.captcha.protect(newsletter, () => { if (!sent) { sent = true; newsletter.requestSubmit(); } }); } catch { status('signupPending'); }
        }
      } else if (matching && p.fields) {
        Object.entries(p.fields).forEach(([name, value]) => { const input = form.elements.namedItem(name); if (input) input.value = value; });
        form.querySelector('[data-print-help-marketing]').checked = p.marketing;
        form.closest('.do3d-print-help').open = true;
      }
    });
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('form[data-lph-newsletter]')) {
      const p = read();
      if (!p || p.version !== 2 || p.stage !== 'customer' || !p.marketing || p.path !== location.pathname || form.dataset.lphNewsletter !== p.id || !p.fields?.['contact[email]']) { event.preventDefault(); return; }
      form.elements['contact[email]'].value = p.fields['contact[email]'];
      return;
    }
    if (!form.matches('form[data-print-help]')) return;
    const marketing = form.querySelector('[data-print-help-marketing]').checked;
    form.elements['contact[Marketing preference]'].value = marketing ? 'Yes — separate optional newsletter signup requested' : 'No';
    const fields = {};
    ['contact[email]', ...optional].forEach(name => { fields[name] = form.elements[name].value; });
    try { save({version:2,stage:'contact',id:form.id,path:location.pathname,time:Date.now(),marketing,fields}); } catch {}
  }, true);
  document.addEventListener('formdata', event => {
    if (!event.target.matches('form[data-print-help]')) return;
    for (const key of optional) {
      const value = String(event.formData.get(key) || '').trim();
      if (value && value !== '---') event.formData.set(key, value);
      else event.formData.delete(key);
    }
  }, true);
  window.addEventListener('pageshow', event => {
    if (event.persisted) initialize();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["do3d-market-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do3d-launch-price')) {
  customElements.define('do3d-launch-price', class extends HTMLElement {
    connectedCallback() {
      this.updateOffer = () => {
        const active = Date.now() < Date.parse(this.dataset.ends);
        this.querySelector('[data-launch-base]').hidden = active;
        this.querySelector('[data-launch-offer]').hidden = !active;
        clearTimeout(this.offerTimer);
        if (active) this.offerTimer = setTimeout(this.updateOffer, Math.min(Date.parse(this.dataset.ends) - Date.now() + 50, 2147483647));
      };
      this.updateOffer();
    }
    disconnectedCallback() { clearTimeout(this.offerTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["do3d-restock-request"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'do3d-product-notify-pending';
  const read = () => { try { const p = JSON.parse(sessionStorage.getItem(key)); if (!p || Date.now() - p.time >= 1800000) { sessionStorage.removeItem(key); return null; } return p; } catch { return null; } };
  const save = p => sessionStorage.setItem(key, JSON.stringify(p));
  const message = (box, type) => box.querySelector('[data-flow-status]').dataset[type];
  const status = (box, type) => { const el = box.querySelector('[data-flow-status]'); el.hidden = false; el.textContent = message(box, type); };
  const cleanResultURL = () => { const url = new URL(location.href); if (url.searchParams.get('do3d_preview_theme') === '189010804930') url.searchParams.set('preview_theme_id', '189010804930'); url.searchParams.delete('contact_posted'); url.searchParams.delete('customer_posted'); url.hash = ''; history.replaceState(null, '', url.pathname + url.search); };
  const finish = (box, p, result) => {
    p.stage = 'done'; p.result = result; delete p.email; save(p);
    const el = document.getElementById(box.id + '-confirmation');
    el.hidden = false; el.textContent = message(box, result);
    box.open = false;
    box.querySelector('[data-restock-contact]').hidden = true;
    box.querySelector('[data-marketing-stage]').hidden = true;
    cleanResultURL();
  };
  const configureNewsletter = (newsletter, p) => {
    newsletter.elements['contact[email]'].value = p.email;
    const field = newsletter.elements['contact[tags]'];
    const tags = field.dataset.baseTags.split(',').filter(Boolean);
    if (p.restock && p.marketing && /^\d+$/.test(p.variant || '') && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(p.token || '')) {
      tags.push('do3d-restock-variant-' + p.variant);
      tags.push('do3d-restock-request-' + p.variant + '-' + p.token);
    }
    field.value = [...new Set(tags)].join(',');
  };
  const initialize = () => {
    document.querySelectorAll('[data-flow-submit]').forEach(button => { button.disabled = false; });
    const p = read();
    if (!p || p.path !== location.pathname) return;
    const box = document.getElementById(p.id);
    if (!box) return;
    const contact = box.querySelector('[data-restock-contact]');
    const stage = box.querySelector('[data-marketing-stage]');
    const newsletter = stage.querySelector('form');
    if (p.stage === 'done') { finish(box, p, p.result); return; }
    contact.querySelector('[data-request-email]').value = p.email;
    contact.querySelector('[data-marketing-choice]').checked = p.marketing;
    contact.querySelector('[data-restock-choice]').checked = p.restock;
    const expected = p.stage === 'contact' ? contact : newsletter;
    const result = expected.querySelector(p.stage === 'contact' ? '[data-contact-result]' : '[data-marketing-result]');
    const accepted = (p.stage === 'contact' ? result.dataset.contactResult : result.dataset.marketingResult) === 'true' && result.dataset.errors === 'false';
    const correctTarget = location.hash === '#' + expected.id;
    if (accepted && correctTarget) {
      if (p.stage === 'customer') { finish(box, p, 'bothOk'); return; }
      p.contactDone = true;
      if (!p.marketing) { finish(box, p, 'contactOk'); return; }
      contact.hidden = true; box.open = true; stage.hidden = false; status(box, 'pending');
      p.stage = 'customer'; save(p);
      configureNewsletter(newsletter, p);
      cleanResultURL();
      if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(newsletter, () => newsletter.requestSubmit());
    } else {
      box.open = true;
      if (p.contactDone) {
        contact.hidden = true; stage.hidden = false; status(box, 'failed');
        configureNewsletter(newsletter, p);
      } else { status(box, 'unverified'); }
    }
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-restock-flow]')) {
      const button = event.target.querySelector('[data-flow-submit]');
      const slot = event.target.closest('[data-do3d-restock-slot]');
      if (button && (!slot || slot.dataset.variantState === 'ready')) button.disabled = false;
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-restock-contact]')) return;
    const slot = form.closest('[data-do3d-restock-slot]');
    if (slot && slot.dataset.variantState !== 'ready') {
      event.preventDefault();
      return;
    }
    const box = form.closest('[data-restock-flow]');
    const marketing = form.querySelector('[data-marketing-choice]').checked;
    const restock = form.querySelector('[data-restock-choice]').checked;
    if (!marketing && !restock) { event.preventDefault(); form.querySelector('[data-restock-choice]').focus(); return; }
    const existing = read();
    const email = form.querySelector('[data-request-email]').value.trim();
    const variant = box.dataset.requestVariant;
    const reuseAttempt = existing && existing.id === box.id && existing.path === location.pathname && existing.stage === 'contact' && existing.variant === variant && existing.email?.toLowerCase() === email.toLowerCase() && existing.marketing === marketing && existing.restock === restock;
    const p = {id:box.id, path:location.pathname, token:reuseAttempt ? existing.token : crypto.randomUUID(), stage:'contact', email, variant, marketing, restock, time:reuseAttempt ? existing.time : Date.now()};
    try { save(p); } catch { event.preventDefault(); status(box, 'storage'); return; }
    form.dataset.flowPrepared = p.token;
    form.querySelector('[data-request-time]').value = new Date().toISOString();
    form.querySelector('[data-marketing-state]').value = marketing ? 'Yes — email me free models, deals and new releases; subscription step follows request.' : 'No';
    form.querySelector('[data-restock-state]').value = restock ? 'Yes — email me when this product is back in stock.' : 'No — no restock email requested.';
    cleanResultURL();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do3d-launch-price')) {
  customElements.define('do3d-launch-price', class extends HTMLElement {
    connectedCallback() {
      this.updateOffer = () => {
        const active = Date.now() < Date.parse(this.dataset.ends);
        this.querySelector('[data-launch-base]').hidden = active;
        this.querySelector('[data-launch-offer]').hidden = !active;
        clearTimeout(this.offerTimer);
        if (active) this.offerTimer = setTimeout(this.updateOffer, Math.min(Date.parse(this.dataset.ends) - Date.now() + 50, 2147483647));
      };
      this.updateOffer();
    }
    disconnectedCallback() { clearTimeout(this.offerTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
